import React from "react";
import { useTranslation } from "react-i18next";
import { Divider } from "antd";
import QuoteForm from "./QuoteForm";

const OPENING_HOURS = ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag"].map(day => ({
  day,
  hours: "8:00–17:00"
}));

const GetStarted = () => {
  const { t } = useTranslation();

  return (
    <section id="get-started" className="get-started section">
      <div className="container">
        <div className="row justify-content-between gy-4">
          <div
            className="col-12 col-lg-6 d-flex align-items-center"
            data-aos="zoom-out"
            data-aos-delay="100"
          >
            <div className="content">
              <h3>{t("Contract.heading")}</h3>
              <p>{t("Contract.desc1")}</p>
              <p>{t("Contract.desc2")}</p>
              <p>{t("Contract.desc3")}</p>
            </div>
          </div>

          <div className="col-12 col-lg-5" data-aos="zoom-out" data-aos-delay="200">
            <QuoteForm ns="Contract" showTitle />
          </div>

          <div className="col-12">
            <Divider>{t("Unsere Öffnungszeiten")}</Divider>
            <dl className="opening-hours">
              {OPENING_HOURS.map(({ day, hours }) => (
                <div className="opening-hours__row" key={day}>
                  <dt>{t(day)}</dt>
                  <dd>{hours}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetStarted;
